// Libraries
import { action, observable, reaction } from 'mobx';
import { User } from '.';
import { app } from '../App';

// Interfaces
import { IQuestionWithOptionInfo } from 'common/interfaces/question';

// Store
export class Question {
  constructor(private user: User) {}

  private reactToUserLogin = reaction(
    () => this.user.id,
    (id) => {
      if (id !== null) {
        this.fetchAllQuestionWithOptions();
      }
    }
  );

  @observable public loading: boolean = false;
  @observable public questionWithOptionInfo: IQuestionWithOptionInfo[] = [];

  // Fetch all questions
  @action public fetchAllQuestionWithOptions = async (): Promise<any> => {
    try {
      this.loading = true;
      this.questionWithOptionInfo = [];

      const service = await app.service('question-with-option');
      const questionWithOptionInfo: IQuestionWithOptionInfo[] = await service.find();
      this.questionWithOptionInfo = questionWithOptionInfo;

      return questionWithOptionInfo;
    } catch (err) {
      console.error(err);
      return err;
    } finally {
      this.loading = false;
    }
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/stores/Question.ts